<template>
  <div class="grid-module">
    <div class="header">
      <h1>E-mails</h1>
      <div class="tabs">
        <div
          v-if="checkAccess(p.manage.emails.template.access)"
          role="button"
          :class="{ 'is-active': isActive(tab.templates), 'tab': true }"
          @click="activeTab = tab.templates"
        >
          Templates
        </div>
        <div
          v-if="checkAccess(p.manage.emails.template.access)"
          role="button"
          :class="{ 'is-active': isActive(tab.types), 'tab': true }"
          @click="activeTab = tab.types"
        >
          Events
        </div>
        <div
          v-if="checkAccess(p.manage.emails.unsubscribers.access)"
          role="button"
          :class="{ 'is-active': isActive(tab.unsubscribers), 'tab': true }"
          @click="activeTab = tab.unsubscribers"
        >
          Unsubscribers
        </div>
      </div>
    </div>
    <EmailTemplates v-if="isActive(tab.templates) && checkAccess(p.manage.emails.template.access)">
    </EmailTemplates>
    <EmailUnsubscribers
      v-if="isActive(tab.unsubscribers) && checkAccess(p.manage.emails.unsubscribers.access)">
    </EmailUnsubscribers>
    <EmailTypes  v-if="isActive(tab.types) && checkAccess(p.manage.emails.template.access)">
    </EmailTypes>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EmailTemplates from '../components/EmailTemplates.vue';
import EmailTypes from '../components/EmailTypes.vue';
import EmailUnsubscribers from '../components/EmailUnsubscribers.vue';
import permission from '../assets/Permissions';

export default {
  name: 'ManageEmails',
  components: { EmailTemplates, EmailUnsubscribers, EmailTypes },
  data() {
    return {
      p: permission,
      tab: {
        templates: 'TEMPLATES',
        unsubscribers: 'UNSUBSCRIBERS',
        types: 'EVENTS',
      },
      loading: false,
      activeTab: 'TEMPLATES',
    };
  },

  activated() {
    if (
      this.activeTab === this.tab.templates
      && !this.checkAccess(this.p.manage.emails.template.access)
    ) {
      this.activeTab = this.tab.unsubscribers;
    }
  },

  computed: {
    ...mapGetters({
      checkAccess: 'authAuthenticator',
    }),
  },

  methods: {
    isActive(tabIdx) {
      return this.activeTab === tabIdx;
    },
  },
};
</script>

<style lang="stylus" scoped>
.tabs
  display flex
  justify-content start
  border-bottom 1px solid rgba(143, 167, 179, 0.3)
  overflow visible
  font-size 18px
  .tab
    cursor pointer
    margin 0 15px
    padding-bottom: 18px
    &:first-child
      margin: 0 15px 0 0
    &.is-active
      position relative
      font-weight 700
      &:after
        content: ''
        position absolute
        bottom -1.5px
        left 0
        width 100%
        height 3px
        background rgba(23, 181, 72, 1)
</style>
